module.exports = __webpack_public_path__ + "static/img/brand-07.6934dd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand-07.png
// module id = Hs1E
// module chunks = 1